var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading && _vm.products && _vm.products.length > 0)?_c('ProductsCarousel',{attrs:{"products":_vm.products,"title":_vm.$t('Customers also bought')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }